import React from "react";
// import "./App.css";
import "./styles/custom.css";
import HomePage from "./Components/Pages/HomePage";

function App() {
  return (
    <div className="App">
      <HomePage />
    </div>
  );
}

export default App;
